const api = '/api/v1/wgroup.php';
import axios from 'axios';
export const wgroupRepository =  {
    methods: {
        async getAll(){
            return  axios.get(api
            );
        },
        async setAll(json){
            return  axios.post(api,json
            );
        },
    }
};

